import * as _ from 'lodash';

import { ContextualField, PropertyType, IMeasurable } from '../../../models';

export const variableProperties: ContextualField[] = [
    {
        modelName: 'variableTypeGuid',
        propertyType: PropertyType.VariableType,
        label: 'Variable type',
        placeholder: 'Variable type',
        propertyName: 'variableTypeGuidProperty',
        icon: 'fa-neuter',
        required: true,
        extraData: {
            allowUndefined: false
        },
        messages: [
            { key: 'required', value: 'A variable type is required' },
        ]
    },
    {
        modelName: 'variableSubTypeGuid',
        propertyType: PropertyType.VariableSubType,
        label: 'Variable subtype',
        placeholder: 'Variable subtype',
        propertyName: 'variableSubTypeGuidProperty',
        icon: 'fa-neuter',
        iconText: 'S',
        extraData: {
            variableTypeGuid: ''
        },
        messages: [
            { key: 'required', value: 'A variable subtype is required' },
        ]
    },
    {
        modelName: 'qualifierGuid',
        propertyType: PropertyType.Qualifier,
        label: 'Qualifier',
        propertyName: 'qualifierGuidProperty',
        icon: 'fa-neuter',
        iconText: 'Q',
        extraData: {
            variableTypeGuid: ''
        },
        messages: [
            { key: 'required', value: 'A qualifier is required' },
        ]
    },
    {
        modelName: 'unitGuid',
        propertyType: PropertyType.Unit,
        label: 'Unit',
        propertyName: 'unitGuidProperty',
        icon: 'fa-balance-scale',
        extraData: {
            variableTypeGuid: ''
        },
        messages: [
            { key: 'required', value: 'A unit is required' },
        ]
    }
];

export function configureVariableTypeProperties(
    properties: ContextualField[],
    selectedItem: IMeasurable,
    extraFields: string[] = [])
{
    const variableType = properties.find(p => p.modelName === 'variableTypeGuid');
    if (variableType) {
        const fields = ['variableSubTypeGuid', 'qualifierGuid', 'unitGuid'].concat(extraFields);
        const  props = properties.filter(p => fields.indexOf(p.modelName) >= 0);
        props.forEach(p => p.extraData.variableTypeGuid = selectedItem.variableTypeGuid);
        variableType.onChange = value => {
            props.forEach(p => p.extraData.variableTypeGuid = value);
        };
    }
}